let marqueeContent = document.querySelectorAll(".marquee-content");

function closeAllTooltips() {
  document.querySelectorAll(".marquee-tooltip").forEach(tooltip => {
    if(tooltip.classList.contains("active")) {
      tooltip.classList.remove("active");
    }
  })
}

  document.querySelectorAll(".tooltip-header svg").forEach(closeIcon => {
    closeIcon.addEventListener("click", (event) => {
      closeAllTooltips();
    })
  })

  window.addEventListener("click", (event) => {
    if(!event.target.classList.contains('marquee-btn-text')) {
      closeAllTooltips();
    }
  })

  document.querySelectorAll(".marquee-button").forEach((button) => {
        button.addEventListener("click", () => {
          let btnData = button.querySelector(".marquee-btn-text").innerText;

          closeAllTooltips();

          document
            .querySelectorAll(`[data-for="${btnData}"]`)
            .forEach((tooltip) => {
              tooltip.classList.add("active");
            });
        });
      });